import { render, staticRenderFns } from "./CatalogueEvent.vue?vue&type=template&id=3454d536&scoped=true&"
import script from "./CatalogueEvent.vue?vue&type=script&lang=js&"
export * from "./CatalogueEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454d536",
  null
  
)

export default component.exports